import { RgbColorPicker } from 'react-colorful';
import styled from 'styled-components';

const StyledColorPickerContainer = styled.div<{ $expanded: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 360px;
	height: 462px;
	padding: 20px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.95);
	overflow: hidden;
	isolation: isolate;

	${({ $expanded }) =>
		!$expanded &&
		`
		height: 110px;
	`}
	transition: height 0.25s ease;
`;

const StyledColorPicker = styled(RgbColorPicker)`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100% !important;
	height: 280px !important;

	.react-colorful__saturation {
		height: 240px !important;
		border-radius: 10px !important;
		border: none !important;
		box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.25);

		.react-colorful__interactive {
			left: 10px;
			top: 10px;
			width: calc(100% - 20px);
			height: calc(100% - 20px);
		}
	}

	.react-colorful__hue {
		width: 100%;
		height: 20px !important;
		border-radius: 6px !important;
		border: none !important;
		background-image: linear-gradient(
			90deg,
			red 0,
			#ff0 17%,
			#0f0 33%,
			#0ff 50%,
			#00f 67%,
			#f0f 83%,
			red
		) !important;

		.react-colorful__interactive {
			left: 10px !important;
			right: 10px !important;
			top: 0 !important;
			bottom: 0 !important;
			width: auto !important;
		}
	}

	.react-colorful__pointer {
		width: 10px !important;
		height: 10px !important;
		padding: 5px;
		background-clip: content-box;
		box-shadow: initial !important;
		border: 5px solid rgba(0, 0, 0, 0.25) !important;

		.react-colorful__pointer-fill {
			background-color: white !important;
		}

		outline: none !important;
	}

	.react-colorful__interactive:focus .react-colorful__pointer {
		transform: translate(-50%, -50%) !important;
	}
`;

const StyledHeadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledCloseButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background-color: rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	cursor: pointer;
	opacity: 0;
	transition:
		background-color 0.25s ease,
		opacity 0.25s ease;

	&:hover {
		background-color: rgba(0, 0, 0, 1);

		img {
			filter: invert(0);
		}
	}

	img {
		width: 12px;
		height: 12px;
		transform: rotate(45deg);
		user-select: none;
		pointer-events: none;
		filter: invert(100%);
		transition: filter 0.25s ease;
	}

	&.button-enter {
		opacity: 0;
	}

	&.button-enter-active,
	&.button-enter-done,
	&.button-exit {
		opacity: 1;
	}

	&.button-exit-active {
		opacity: 0;
	}
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: rgba(0, 0, 0, 0.1);
`;

const StyledColorsContainer = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 20px;
	height: 30px;
	opacity: 0;
	margin-top: 20px;
	pointer-events: none;
	overflow: hidden;
	transition:
		height 0.25s ease,
		margin-top 0.25s ease,
		opacity 0.25s ease;

	&.color-enter {
		opacity: 0;
	}

	&.color-enter-active,
	&.color-enter-done,
	&.color-exit {
		height: 30px;
		margin-top: 20px;
		opacity: 1;
		pointer-events: all;
	}

	&.color-exit-active {
		height: 0;
		margin-top: 0;
		opacity: 0;
	}
`;

const StyledColorInputsContainer = styled.div`
	margin-top: 20px;
`;

export {
	StyledColorPickerContainer,
	StyledColorPicker,
	StyledDivider,
	StyledColorsContainer,
	StyledHeadingContainer,
	StyledCloseButton,
	StyledColorInputsContainer,
};
